import {Component, OnInit, inject} from '@angular/core';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {MatMenuModule} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {TablerIconsModule} from 'angular-tabler-icons';
import {Roles} from '@core/enums/Roles';
import {User} from '@interfaces/user';
import {AuthService} from '@services/api/auth/auth.service';
import {LogoutService} from '@services/api/logout/logout.service';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, MatMenuModule, TranslateModule, TablerIconsModule],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
})
export class AdminLayoutComponent implements OnInit {
  private userStorage = inject(UserStorageService);
  private authService = inject(AuthService);
  private logoutService = inject(LogoutService);
  private router = inject(Router);

  user: User | null = null;

  ngOnInit(): void {
    this.userStorage.getUserStorage().then((user) => (this.user = user));
  }

  get isPlatformAdmin(): boolean {
    return this.user?.roles?.id === Roles.SUPER_ADMIN;
  }

  get canManageUsers(): boolean {
    return this.isPlatformAdmin || this.user?.roles?.id === Roles.MANAGEMENT_SYSTEM;
  }

  get userInitials(): string {
    const name = `${this.user?.name ?? ''} ${this.user?.lastname ?? ''}`.trim();
    const source = name || this.user?.email || '?';
    return source.split(/\s+/).map((p) => p[0]).join('').slice(0, 2).toUpperCase();
  }

  goToDocuments(): void {
    this.router.navigate(['/documents']);
  }

  logout(): void {
    this.authService.logout().subscribe({
      complete: () => this.logoutService.logout(),
      error: () => this.logoutService.logout(),
    });
  }
}
